import { z } from "zod";

export const PHOTO_ROULETTE_STATUS = {
	NONE: "none",
	LOBBY: "lobby",
	IN_ROUND: "in_round",
	BETWEEN_ROUNDS: "between_rounds",
	ENDED: "ended",
	CANCELED: "canceled",
} as const;

export type PhotoRouletteStatus = (typeof PHOTO_ROULETTE_STATUS)[keyof typeof PHOTO_ROULETTE_STATUS];

export const photoRouletteStatusSchema = z.enum([
	PHOTO_ROULETTE_STATUS.NONE,
	PHOTO_ROULETTE_STATUS.LOBBY,
	PHOTO_ROULETTE_STATUS.IN_ROUND,
	PHOTO_ROULETTE_STATUS.BETWEEN_ROUNDS,
	PHOTO_ROULETTE_STATUS.ENDED,
	PHOTO_ROULETTE_STATUS.CANCELED,
]);

export const PHOTO_ROULETTE_CANCEL_REASONS = {
	HOST_LEFT: "host_left",
	LOBBY_EXPIRED: "lobby_expired",
	MANUAL: "manual",
	STALE: "stale",
	NOT_ENOUGH_PLAYERS: "not_enough_players",
	LAST_PLAYER_REMAINING: "last_player_remaining",
} as const;

export type PhotoRouletteCancelReason = (typeof PHOTO_ROULETTE_CANCEL_REASONS)[keyof typeof PHOTO_ROULETTE_CANCEL_REASONS];

export const photoRouletteCancelReasonSchema = z.enum([
	PHOTO_ROULETTE_CANCEL_REASONS.HOST_LEFT,
	PHOTO_ROULETTE_CANCEL_REASONS.LOBBY_EXPIRED,
	PHOTO_ROULETTE_CANCEL_REASONS.MANUAL,
	PHOTO_ROULETTE_CANCEL_REASONS.STALE,
	PHOTO_ROULETTE_CANCEL_REASONS.NOT_ENOUGH_PLAYERS,
	PHOTO_ROULETTE_CANCEL_REASONS.LAST_PLAYER_REMAINING,
]);

export const PHOTO_ROULETTE_ROUND_DURATION_MS = 10_000;
export const PHOTO_ROULETTE_LOBBY_TTL_MS = 5 * 60 * 1000;
export const PHOTO_ROULETTE_LOBBY_AUTO_START_MS = 60 * 1000;
export const PHOTO_ROULETTE_STALE_GAME_THRESHOLD_MS = 15 * 60 * 1000;
export const PHOTO_ROULETTE_BETWEEN_ROUNDS_MS = 1_000;
export const PHOTO_ROULETTE_MIN_PLAYERS = 2;
export const PHOTO_ROULETTE_MIN_DISTINCT_AUTHORS = 2;
export const PHOTO_ROULETTE_MIN_GROUP_MEMBERS = 2;
export const PHOTO_ROULETTE_BASE_POINTS = 10;
export const PHOTO_ROULETTE_MAX_SPEED_BONUS = 5;

export const PHOTO_ROULETTE_MIN_NUMBER_OF_PHOTOS = 4;
export const PHOTO_ROULETTE_MAX_NUMBER_OF_PHOTOS = 30;
export const PHOTO_ROULETTE_DEFAULT_NUMBER_OF_PHOTOS = 5;
export const PHOTO_ROULETTE_ABSOLUTE_MIN_PHOTOS = PHOTO_ROULETTE_MIN_NUMBER_OF_PHOTOS;

export const PHOTO_ROULETTE_REACTION_EMOJIS = ["😂", "🤬", "👍", "🥲", "🎉"] as const;
export type PhotoRouletteReactionEmoji = (typeof PHOTO_ROULETTE_REACTION_EMOJIS)[number];
export const photoRouletteReactionEmojiSchema = z.enum(PHOTO_ROULETTE_REACTION_EMOJIS);
